export class CurrentUserLoggedIn {
  // userInfo: UserBasicInformation = new UserBasicInformation();
  token: string;
  userName: string;
  roles: string[] = [];
  id: string;
  userType: number;
  fullName: string;
  fullNameEn: string;
  profileImg?: string;
  classId: number;
  expiration: string;
  fileUrl: string;
  isLook: boolean;
  sasToken: string;
  sectionId: number;
  className?: string;
  classNameEn?: string;
  schoolId?: number;
  schoolName?: string;
  schoolNameEn?: string;
  sectionName?: string;
  sectionNameEn?: string;
}
